/* eslint-disable max-len */

export const FETCH_MASTER_ACCOUNTS = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_MASTER_ACCOUNTS';
export const FETCH_MASTER_ACCOUNTS_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_MASTER_ACCOUNTS_SUCCESS';
export const FETCH_MASTER_ACCOUNTS_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_MASTER_ACCOUNTS_ERROR';

export const CHECK_MASTER_ACCOUNTS_PROHIBITION = 'SETTINGS:NUMBER_MANAGEMENT:CHECK_MASTER_ACCOUNTS_PROHIBITION';
export const CHECK_MASTER_ACCOUNTS_PROHIBITION_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:CHECK_MASTER_ACCOUNTS_PROHIBITION_SUCCESS';
export const CHECK_MASTER_ACCOUNTS_PROHIBITION_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:CHECK_MASTER_ACCOUNTS_PROHIBITION_ERROR';

export const UPDATE_MASTER_ACCOUNTS_PROHIBITION = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_MASTER_ACCOUNTS_PROHIBITION';
export const UPDATE_MASTER_ACCOUNTS_PROHIBITION_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_MASTER_ACCOUNTS_PROHIBITION_SUCCESS';
export const UPDATE_MASTER_ACCOUNTS_PROHIBITION_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_MASTER_ACCOUNTS_PROHIBITION_ERROR';

export const FETCH_ASSOCIATED_ACCOUNTS = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_ASSOCIATED_ACCOUNTS';
export const FETCH_ASSOCIATED_ACCOUNTS_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_ASSOCIATED_ACCOUNTS_SUCCESS';
export const FETCH_ASSOCIATED_ACCOUNTS_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_ASSOCIATED_ACCOUNTS_ERROR';

export const UPDATE_ASSOCIATED_ACCOUNT = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_ASSOCIATED_ACCOUNT';
export const UPDATE_ASSOCIATED_ACCOUNT_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_ASSOCIATED_ACCOUNT_ERROR';
export const UPDATE_ASSOCIATED_CTN_ACCOUNT_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_ASSOCIATED_CTN_ACCOUNT_SUCCESS';
export const UPDATE_ASSOCIATED_BAN_ACCOUNT_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_ASSOCIATED_BAN_ACCOUNT_SUCCESS';
export const UPDATE_ASSOCIATED_BEN_ACCOUNT_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_ASSOCIATED_BEN_ACCOUNT_SUCCESS';

export const CREATE_ACCOUNT_LINK = 'SETTINGS:NUMBER_MANAGEMENT:CREATE_ACCOUNT_LINK';
export const CREATE_ACCOUNT_LINK_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:CREATE_ACCOUNT_LINK_SUCCESS';
export const CREATE_ACCOUNT_LINK_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:CREATE_ACCOUNT_LINK_ERROR';

export const DELETE_ACCOUNT_LINK = 'SETTINGS:NUMBER_MANAGEMENT:DELETE_ACCOUNT_LINK';
export const DELETE_ACCOUNT_LINK_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:DELETE_ACCOUNT_LINK_SUCCESS';
export const DELETE_ACCOUNT_LINK_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:DELETE_ACCOUNT_LINK_ERROR';

export const DELETE_MASTER_ACCOUNT_LINK = 'SETTINGS:NUMBER_MANAGEMENT:DELETE_MASTER_ACCOUNT_LINK';
export const DELETE_MASTER_ACCOUNT_LINK_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:DELETE_MASTER_ACCOUNT_LINK_SUCCESS';
export const DELETE_MASTER_ACCOUNT_LINK_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:DELETE_MASTER_ACCOUNT_LINK_ERROR';

export const CANCEL_LINKAGE_REQUEST = 'SETTINGS:NUMBER_MANAGEMENT:CANCEL_LINKAGE_REQUEST';
export const CANCEL_LINKAGE_REQUEST_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:CANCEL_LINKAGE_REQUEST_SUCCESS';
export const CANCEL_LINKAGE_REQUEST_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:CANCEL_LINKAGE_REQUEST_ERROR';

export const FETCH_LINKAGE_REQUESTS = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_LINKAGE_REQUESTS';
export const FETCH_LINKAGE_REQUESTS_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_LINKAGE_REQUESTS_SUCCESS';
export const FETCH_LINKAGE_REQUESTS_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_LINKAGE_REQUESTS_ERROR';

export const FETCH_LINKAGE_REQUESTS_FOR_MASTER = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_LINKAGE_REQUESTS_FOR_MASTER';
export const FETCH_LINKAGE_REQUESTS_FOR_MASTER_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_LINKAGE_REQUESTS_FOR_MASTER_SUCCESS';
export const FETCH_LINKAGE_REQUESTS_FOR_MASTER_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_LINKAGE_REQUESTS_FOR_MASTER_ERROR';

export const UPDATE_LINKAGE_REQUEST = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_LINKAGE_REQUEST';
export const UPDATE_LINKAGE_REQUEST_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_LINKAGE_REQUEST_SUCCESS';
export const UPDATE_LINKAGE_REQUEST_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_LINKAGE_REQUEST_ERROR';

export const FETCH_OFFER = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_OFFER';
export const FETCH_OFFER_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_OFFER_SUCCESS';
export const FETCH_OFFER_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_OFFER_ERROR';

export const TOGGLE_OFFER_POPUP = 'SETTINGS:NUMBER_MANAGEMENT:TOGGLE_OFFER_POPUP';

export const FETCH_LOGIN_USER_TYPES = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_LOGIN_USER_TYPES';
export const FETCH_LOGIN_USER_TYPES_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_LOGIN_USER_TYPES_SUCCESS';
export const FETCH_LOGIN_USER_TYPES_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_LOGIN_USER_TYPES_ERROR';
export const RESET_LOGIN_USER_TYPES = 'SETTINGS:NUMBER_MANAGEMENT:RESET_LOGIN_USER_TYPES';

export const RESET_ACCOUNT_LINKING_STATUS = 'SETTINGS:NUMBER_MANAGEMENT:RESET_ACCOUNT_LINKING_STATUS';

export const SEND_ACCOUNT_LINK_REQUEST_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:SEND_ACCOUNT_LINK_REQUEST_SUCCESS';

export const CANCEL_LINKAGE_REQUEST_FOR_MASTER = 'SETTINGS:NUMBER_MANAGEMENT:CANCEL_LINKAGE_REQUEST_FOR_MASTER';
export const CANCEL_LINKAGE_REQUEST_FOR_MASTER_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:CANCEL_LINKAGE_REQUEST_FOR_MASTER_SUCCESS';

export const UPDATE_LINKAGE_REQUEST_FOR_MASTER = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_LINKAGE_REQUEST_FOR_MASTER';
export const UPDATE_LINKAGE_REQUEST_FOR_MASTER_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:UPDATE_LINKAGE_REQUEST_FOR_MASTER_SUCCESS';

export const RESET_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:RESET_ERROR';
export const RESET_ASSOCIATED_ACCOUNTS_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:RESET_ASSOCIATED_ACCOUNTS_ERROR';
export const RESET_MASTER_ACCOUNTS_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:RESET_MASTER_ACCOUNTS_ERROR';

export const SET_MASTER_ACCOUNT_AS_DEFAULT = 'SETTINGS:NUMBER_MANAGEMENT:SET_MASTER_ACCOUNT_AS_DEFAULT';
export const SET_MASTER_ACCOUNT_AS_DEFAULT_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:SET_MASTER_ACCOUNT_AS_DEFAULT_SUCCESS';
export const SET_MASTER_ACCOUNT_AS_DEFAULT_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:SET_MASTER_ACCOUNT_AS_DEFAULT_ERROR';

export const FETCH_PIN_PUK = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_PIN_PUK';
export const FETCH_PIN_PUK_SUCCESS = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_PIN_PUK_SUCCESS';
export const FETCH_PIN_PUK_ERROR = 'SETTINGS:NUMBER_MANAGEMENT:FETCH_PIN_PUK_ERROR';

export const REQUESTS_TYPES = {
  REQUEST: 'REQUEST',
  INVITE: 'INVITE',
};

export const REQUESTS_DURATIONS = {
  IN: 'IN',
  OUT: 'OUT',
};

export const USER_TYPES = {
  MOBILE: 'Mobile',
  FTTB: 'Fttb',
};

export const AMBIGUOUS_USER_TYPE_ERROR = 'AMBIGUOUS_USER_TYPE';

export const OFFER_TYPE = 'CONVERGENCE';

export const ACCOUNT_EDIT_POPUP_KEY = 'SETTINGS:NUMBER_MANAGEMENT:ACCOUNT_EDIT';
export const ACCOUNT_GROUP_EDIT_POPUP_KEY = 'SETTINGS:NUMBER_MANAGEMENT:ACCOUNT_GROUP_EDIT';
export const CONTRACT_EDIT_POPUP_KEY = 'SETTINGS:NUMBER_MANAGEMENT:CONTRACT_EDIT';
export const ASSOCIATE_ACCOUNT_POPUP_KEY = 'SETTINGS:NUMBER_MANAGEMENT:ASSOCIATE_ACCOUNT';
export const ASSOCIATE_MASTER_ACCOUNT_POPUP_KEY = 'SETTINGS:NUMBER_MANAGEMENT:ASSOCIATE_MASTER_ACCOUNT';
export const CONFIRMATION_DELETING_POPUP_KEY = 'SETTINGS:NUMBER_MANAGEMENT:CONFIRMATION_DELETING';
export const CONFIRMATION_MASTER_DELETING_POPUP_KEY = 'SETTINGS:NUMBER_MANAGEMENT:CONFIRMATION_MASTER_DELETING';
